import { formFieldsConfigProcessed } from "./config/FileAttachmentsConfig";
import { formState } from "./state/FileAttachmentsState";
import { formValidation } from "./validations/FileAttachmentsValidations";
import { FILE_ATTACHMENTS_CONSTANTS } from "../../constants";

export const formName = FILE_ATTACHMENTS_CONSTANTS.FORM_NAME;
export const formHeader = FILE_ATTACHMENTS_CONSTANTS.FORM_HEADER;
export const formConfig = formFieldsConfigProcessed;
export { formState, formValidation };

export const FileAttachments = {
  formName,
  formHeader,
  formConfig,
  formState,
  formValidation,
};
